"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normaliseQualities = normaliseQualities;
var _QualityUtils = require("../utils/QualityUtils");
function normaliseQuality(src, quality) {
  var key = (0, _QualityUtils.generateQualityKey)(src, quality.label);
  return {
    index: quality.index,
    key: key,
    width: quality.width || 0,
    height: quality.height || 0,
    bitrate: quality.bitrate,
    label: quality.label.toLowerCase() === _QualityUtils.AUTO_LABEL.toLowerCase() ? _QualityUtils.AUTO_LABEL : quality.label
  };
}
function normaliseQualities(src, nativeQualities) {
  var qualities = (0, _QualityUtils.qualitiesRecord)();
  if (!(0, _QualityUtils.isHLS)(src) || nativeQualities.length <= 2) {
    return qualities;
  }
  for (var i = 0; i < nativeQualities.length; i++) {
    var normalised = normaliseQuality(src, nativeQualities[i]);
    qualities["native"][normalised.key] = nativeQualities[i];
    qualities.normalised.push(normalised);
  }
  qualities.normalised = (0, _QualityUtils.sortQualities)(qualities.normalised);
  return qualities;
}